// extracted by mini-css-extract-plugin
module.exports = {"grey-background":"LimitsAndClosure-LimitsAndClosureScreen-grey-background-14XZWuzk","greyBackground":"LimitsAndClosure-LimitsAndClosureScreen-grey-background-14XZWuzk"};